<div class="main-page">
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <!--  <a class="navbar-brand" routerLink="/dashboard"> <span class="nav-divnk time" ><i class="fa fa-long-arrow-left" style="font-size:48px;color:#fff;margin-top:-16px;"></i></span></a> -->
    <!--  <div class="form-inline my-2 my-lg-0">
        <span  class="nav-divnk">Base Plan</span>
    </div> -->
    <div class="logo"><a (click)="redirectTo()"><img src="assets/logo-4.png"></a></div>


  </nav>



  <div class="container">
    <ngx-spinner></ngx-spinner>
    <div class="plans-area">
      <div class="plans-area-inner">


        <span class="nav-divnk">Choose a Subscription</span>
        <div class="content-part"><img src="assets/logo-5.png"></div>
        <div style="margin-bottom:20px;" class="text-style">Subscribe today and Ravel will donate 10% of your
          subscription<br> fee to the primary
          Fellowship your are affilated to*</div>

        <div style="min-height:300px">

          <div *ngIf="!loading" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div *ngIf="loading" class="plan-name-area">
            <div class="card" *ngFor="let plan of plans" (click)="selectedPlan(plan)">
              <div class="card-header">
                <div class="display" style="justify-content: space-between;">
                  <div> ${{plan.price}}</div>
                  <div>
                    ({{(( plan.days == 1 )? (plan.days) + ' day' : (plan.days) + ' days')}}) {{plan.caption}}
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title">{{plan.description | titlecase}}</h5>
                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                <a href="#" class="btn btn-primary">Go somewhere</a> -->
              </div>
            </div>
          </div>

        </div>


        <!-- <div class="plan-name-area">
          <div *ngFor="let plan of plans" class="row plan-name link" (click)="selectedPlan(plan)">
            <div class="price-cust col-md-4">
              <p>${{plan.price}}</p>
            </div>
            <div class="des-h col-md-8 float-left">
              <p>{{plan.description}} ({{plan.days}}) {{plan.caption}}</p>
            </div>
            <div class="under-line"></div>
            <div class=" col-md-4"></div>

          </div>

        </div> -->
        <div style="margin-top:20px;" class="text-style">Fellowship must have a complete profile as a non-profit
          organization in the US</div>
      </div>
    </div>
    




  </div>






</div>